import React from 'react';
import {
    Form,
    Input,
    Select,
    Col,
    Row,
    InputNumber,
    message,
    Button,
    Popconfirm,
    Tooltip,
    DatePicker,
    Icon,
    Upload, Radio
} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom,uploadEnclosure } from '../../../../axios';
import {dicBuildingStatus, dicRecvCertType} from '../../../../axios/dictionaries';
import province from '../../../../area/province.json';
import city from '../../../../area/city.json';
import area from '../../../../area/area.json';
import {handleExportParams} from "../../../../utils";
import moment from "moment";
import {API_building_deletePayeeMerchant, API_building_deleteRentCycle} from "../../../../axios/config";

const Option = Select.Option;
let filterCity = [];
let filterArea = [];

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "收房合同",
            data: {
                houseLayout: [],
                // 房租周期
                rentCycleList: [],
                //收款银联商户号配置
                payeeMerchantList: []
            },

            modalData: {
                attachList: {}
            },
            radioClarifyValue: false,
            leaseTermTime: {}, //起租日-退租日
        }
    }

    uploadEnclosure = (name, res) => { //上传附件
        let { modalData } = this.state;
        modalData.attachList = [{ name, id: res.attach_id, url: res.attach_url }];
        //  modalData.fileUrl = res.attach_url
        this.setState({ modalData });
    }

    handleDeleteAttach = (index) => { //删除附件
        let { modalData } = this.state;
        modalData.attachList.splice(index, 1);
        this.setState({ modalData });
    }

    handleClarifyChange = (e) => { // 是否清算修改
        const radioClarifyValue = e.target.value
        this.setState({
            radioClarifyValue
        })
    }



    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            modalData,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="编号">
                                    {getFieldDecorator('buildingNo', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.buildingNo
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            disabled={true}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="名称">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            disabled={true}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="省份">
                                    {getFieldDecorator('province', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.province || '广东省'
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            disabled={true}
                                            onChange={(value) => {
                                                setFieldsValue({ city: undefined, area: undefined });
                                                let p = province.find(item => item.name === value);
                                                if (p) {
                                                    filterCity = city.filter((item, index) => item.provinceCode === p.code);
                                                }
                                                filterArea = [];
                                                this.forceUpdate();
                                            }}
                                        >
                                            {province.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="城市">
                                    {getFieldDecorator('city', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.city || '深圳市'
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            disabled
                                            onChange={(value) => {
                                                setFieldsValue({ area: undefined });
                                                let c = city.find(item => item.name === value);
                                                if (c) {
                                                    filterArea = area.filter((item, index) => item.cityCode === c.code);
                                                }
                                                this.forceUpdate();
                                            }}
                                        >
                                            {filterCity.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="区域">
                                    {getFieldDecorator('area', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.area
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            disabled
                                            optionFilterProp={'children'}
                                        >
                                            {filterArea.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="详细地址" colStyle={{ width: '500px' }}>
                                    {getFieldDecorator('address', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.address
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="层高">
                                    {getFieldDecorator('floorCount', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.floorCount
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            disabled
                                            max={99}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择状态"
                                            disabled
                                            optionFilterProp={'children'}
                                        >
                                            {dicBuildingStatus.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <div>
                                <DetailTitle title="收房合同相关信息" />
                                <CustomRow>
                                    <CustomCol label="业主姓名">
                                        {getFieldDecorator('recvName', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.recvName
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                // style={{ width: 274 }}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="业主证件类型">
                                        {getFieldDecorator('recvCertType', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.recvCertType
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                            >
                                                {dicRecvCertType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                            </Select>
                                        )}
                                    </CustomCol>
                                    <CustomCol label="业主证件号码">
                                        {getFieldDecorator('recvCertNo', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.recvCertNo
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                // style={{ width: 274 }}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider>
                                    <CustomCol label="承租月租金">
                                        {getFieldDecorator('payAmtByMonth', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.payAmtByMonth
                                        })(
                                            <InputNumber
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                // style={{ width: 274 }}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="承租押金">
                                        {getFieldDecorator('depositAmt', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.depositAmt
                                        })(
                                            <InputNumber
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                                // style={{ width: 274 }}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="参与商户对账">
                                        {getFieldDecorator('merchantReconciliation', {
                                            rules: [{ required: true, message: '请选择是否参与商户对账' }],
                                            initialValue: (data.merchantReconciliation==null?false:data.merchantReconciliation==1?true:false)
                                        })(
                                            <Radio.Group>
                                                <Radio value={false}>不参与</Radio>
                                                <Radio value>参与</Radio>
                                            </Radio.Group>
                                        )}
                                    </CustomCol>
                                </CustomRow>

                                <CustomRow divider>
                                    <CustomCol label="起租日">
                                        {getFieldDecorator('beginDate', {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: data.beginDate ? moment(data.beginDate) :null
                                        })(
                                            <DatePicker
                                                placeholder={'请选择'}
                                                allowClear={false}
                                                onChange={(date) => {
                                                    setFieldsValue({ 'SELECT-RANGE-TIME': undefined, firstRentStartDate: date });
                                                    let { leaseTermTime: { end } } = this.state;
                                                    this.setState({ leaseTermTime: { start: date, end } });
                                                }}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="到期日">
                                        {getFieldDecorator('endDate', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.endDate ? moment(data.endDate) : null
                                        })(
                                            <DatePicker
                                                placeholder={'请选择'}
                                                allowClear={false}
                                                onChange={(date) => {
                                                    setFieldsValue({ 'SELECT-RANGE-TIME': undefined, lastRentEndDate: date });
                                                    let { leaseTermTime: { start } } = this.state;
                                                    this.setState({ leaseTermTime: { start, end: date } });
                                                }}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                <CustomRow divider>
                                    <CustomCol label="收房合同上传" required={false}  colStyle={{ width: '460px' }}>
                     <span
                         style={{
                             display: 'block',
                             padding: '0 11px',
                             height: '100%',
                             color: modalData.attachList instanceof Array && modalData.attachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                             whiteSpace: 'nowrap',
                             overflowX: 'auto',
                             overflowY: 'hidden',
                         }}
                     >
                      {
                          modalData.attachList instanceof Array && modalData.attachList.length
                              ? modalData.attachList.map((item, index) => {
                                  return <span key={index}>
                                <a
                                    href={item.url}
                                    download
                                    className="showClickDetail"
                                    style={{ color: 'inherit' }}
                                    target="_blank"
                                >{item.name || index + 1}；</a>
                                <Popconfirm
                                    placement="topRight"
                                    title={'此删除操作不可恢复，确定删除吗？'}
                                    onConfirm={() => {
                                        this.handleDeleteAttach(index)
                                    }}
                                    okText="删除"
                                    cancelText="取消"
                                >
                                    <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                        <Icon type="close" />
                                    </span>
                                </Popconfirm>
                            </span>

                              })
                              : "未上传"
                      }
                  </span>
                                    </CustomCol>
                                    <div className="center" style={{ marginLeft: '10px' }}>
                                        <Upload {...uploadEnclosure({ accept: 'application/pdf', tableName: 'project',attachType:"16", success: this.uploadEnclosure })}>
                                            <span className="showClickDetail">上传</span>
                                        </Upload>
                                    </div>
                                </CustomRow>

                                <DetailTitle title="清算信息" />
                                <CustomRow>
                                    <CustomCol label="是否清算">
                                        {getFieldDecorator('clarify', {
                                            rules: [{ required: true, message: '请选择是否清算' }],
                                            initialValue: (data.clarify==null?false:data.clarify==1?true:false)
                                        })(
                                            <Radio.Group onChange={this.handleClarifyChange}>
                                                <Radio value={false}>否</Radio>
                                                <Radio value>是</Radio>
                                            </Radio.Group>
                                        )}
                                    </CustomCol>
                                </CustomRow>
                                {
                                    this.state.radioClarifyValue ? (
                                        <CustomRow divider>
                                            <CustomCol label="开户行网点号">
                                                {getFieldDecorator('balanceAccBankNo', {
                                                    rules: [{ required: true, message: '请输入开户行网点号' }],
                                                    initialValue: data.balanceAccBankNo || ''
                                                })(
                                                    <Input
                                                        placeholder="请输入"
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol  label="账户户名" extra="提示">
                                                {getFieldDecorator('balanceAccName', {
                                                    rules: [{ required: true, message: '请输入账户户名' }],
                                                    initialValue: data.balanceAccName || ''
                                                })(
                                                    <Input
                                                        placeholder="请输入"
                                                    />
                                                )}
                                            </CustomCol>
                                            <CustomCol  label="账户账号" extra="提示">
                                                {getFieldDecorator('balanceAcc', {
                                                    rules: [{ required: true, message: '请输入账户账号' }],
                                                    initialValue: data.balanceAcc || ''
                                                })(
                                                    <Input
                                                        placeholder="请输入"
                                                    />
                                                )}
                                            </CustomCol>
                                        </CustomRow>
                                    ) : null
                                }

                            </div>


                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }
    //房租周期配置减1
    handleMinus = (index) => {
        let { data } = this.state;
        let item = data.rentCycleList[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_building_deleteRentCycle, data: { rentCycleId: item.id } }).then(res => {
                    data.rentCycleList.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.rentCycleList.splice(index, 1);
                this.setState({ data });
            }
        }
    }
    //房租周期配置+1
    handlePlus = () => {
        let { data } = this.state;
        if (data.rentCycleList instanceof Array) {
            if (data.rentCycleList.length) {
                data.rentCycleList.push({ key: data.rentCycleList[data.rentCycleList.length - 1].key + 1, rentCycleA: '', rentCycleB: '', rentCycleC: '' });
            } else {
                data.rentCycleList.push({ key: 0, rentCycleA: '', rentCycleB: '', rentCycleC: '' });
            }
        } else {
            data.rentCycleList = [{ key: 0, rentCycleA: '', rentCycleB: '', rentCycleC: '' }];
        }
        this.setState({ data });
    }

    //银联收款商户号配置+1
    handlePayeeMerchantPlus = () => {
        let { data } = this.state;
        if (data.payeeMerchantList instanceof Array) {
            if (data.payeeMerchantList.length) {
                data.payeeMerchantList.push({ key: data.payeeMerchantList[data.payeeMerchantList.length - 1].key + 1, payeeMerchantA: '', payeeMerchantB: '', payeeMerchantC: '',payeeMerchantD:'',payeeMerchantE:''   });
            } else {
                data.payeeMerchantList.push({ key: 0, payeeMerchantA: '', payeeMerchantB: '', payeeMerchantC: '',payeeMerchantD:'',payeeMerchantE:''    });
            }
        } else {
            data.payeeMerchantList = [{ key: 0, payeeMerchantA: '', payeeMerchantB: '', payeeMerchantC: '',payeeMerchantD:'',payeeMerchantE:''  }];
        }
        this.setState({ data });
    }

    //银联收款商户号配置减1
    handlePayeeMerchantMinus = (index) => {
        let { data } = this.state;
        let item = data.payeeMerchantList[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_building_deletePayeeMerchant, data: { payeeMerchantId: item.id } }).then(res => {
                    data.payeeMerchantList.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.payeeMerchantList.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    isNotJr=()=>{
        return handleExportParams().isJr === 2
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        filterCity = [];
        filterArea = [];
        this.setState({ data: {}, loading: false, title: "收房合同" ,modalData:{attachList:[]},});
    }

    initPack = () => {
        filterCity = city.filter((item, index) => item.provinceCode === '44');
        filterArea = area.filter((item, index) => item.cityCode === '4403');
        this.forceUpdate();
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "收房合同" });
        postFrom({ url: config.API_building_getBuildingById, data: { keyword: id } }).then(res => {
            res.payeeMerchantList = res.payeeMerchantList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱

                item = {
                    key : index,
                    id: item.id || 0,
                    payeeMerchantA: item.owner,
                    payeeMerchantB: item.enterpriseUserNumber,
                    // payeeMerchantC: item.accountNumber,
                    // payeeMerchantD: item.bankName,
                    payeeMerchantE: item.rent,
                };
                return item
            });

            res.rentCycleList = res.rentCycleList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                item = {
                    id: item.id || 0,
                    key : index,
                    rentCycleA: item.cycleStart,
                    rentCycleB: item.cycleEnd,
                    rentCycleC: item.rent,
                };
                return item
            });

            let p = province.find(item => item.name === res.province);
            let c = city.find(item => item.name === res.city);

            if (res.houseContractUrl) {
                let { modalData } = this.state;
                modalData.attachList= [{ url: res.houseContractUrl,id:0,name: res.houseContractName}];
                this.setState({ modalData });
            }

            filterCity = city.filter((item, index) => (item.provinceCode === res.province || (p ? p.code === item.provinceCode : false)));
            filterArea = area.filter((item, index) => (item.cityCode === res.city || (c ? c.code === item.cityCode : false)));

            this.setState({ data: res, loading: false,radioClarifyValue: (res.clarify==null?false:res.clarify==1?true:false) });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                let { data: { rentCycleList,payeeMerchantList } } = this.state;
                this.setState({ loading: true });

                let valueKeys = Object.keys(values);
                //收款账号配置
                let fKeys = valueKeys.filter((item, index) => {
                    if (/^payeeMerchantA[\d]+$/.test(item)) return item;
                });
                values.payeeMerchantList = fKeys.map((item, index) => { //处理户型字段
                    let id = payeeMerchantList[index].id;
                    let num = item.slice(14);
                    item = {
                        id: id || 0,
                        owner: values[`payeeMerchantA${num}`],
                        enterpriseUserNumber: values[`payeeMerchantB${num}`],
                        // accountNumber: values[`payeeMerchantC${num}`],
                        // bankName: values[`payeeMerchantD${num}`],
                        rent: values[`payeeMerchantE${num}`]
                    };
                    delete values[`payeeMerchantA${num}`];
                    delete values[`payeeMerchantB${num}`];
                    delete values[`payeeMerchantC${num}`];
                    delete values[`payeeMerchantD${num}`];
                    delete values[`payeeMerchantE${num}`];
                    return item
                });

                //收款账号配置
                let rentCycleKeys = valueKeys.filter((item, index) => {
                    if (/^rentCycleA[\d]+$/.test(item)) return item;
                });
                values.rentCycleList = rentCycleKeys.map((item, index) => {
                    let id = rentCycleList[index].id;
                    let num = item.slice(10);
                    item = {
                        id: id || 0,
                        cycleStart: values[`rentCycleA${num}`],
                        cycleEnd: values[`rentCycleB${num}`],
                        rent: values[`rentCycleC${num}`]
                    };
                    delete values[`rentCycleA${num}`];
                    delete values[`rentCycleB${num}`];
                    delete values[`rentCycleC${num}`];
                    return item
                });


                let attachList=this.state.modalData.attachList;
                values.clarify=this.state.radioClarifyValue?1:2;
                values.merchantReconciliation = values.merchantReconciliation?1:2;
                values.houseContractUrl= Array.isArray(attachList) ? attachList.map(item => item.url).join('|') : '',
                    values.houseContractName = Array.isArray(attachList) ? attachList.map(item => item.name).join('|') : '',
                    this.setState({ loading: true });
                if (values.id) {
                    post({ url: config.API_building_editHousingContract, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    this.props.handleGetList();
                    this.handleCancel();
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/AcceptHousingContractAdd/index.js